<template>
  <div id="mobile-slider" class="slider w-screen" :class="sliderClasses">
    <div class="flex justify-between items-center w-90p pl-4.5 mb-7.5">
      <p class="uppercase font-medium fz-10" style="line-height: 1; color: #6e758d; letter-spacing: 0.3rem" >{{ projects }}</p>
      <div class="pagination flex" :class="paginationContainerClasses">
        <div
            :id="'pagination-' + index"
            @click="paginationClickHandler(index)"
            v-for="(item, index) in slides"
            :key="item"
        >
          <slot name="pagination"></slot>
        </div>
      </div>
    </div>
    <div class="relative">
      <a href="#mobile-start">
        <img
          src="@/assets/images/eye-circle.svg"
          @click="setProject([...controlPoints].reverse().indexOf(chosePoint))"
          class="w-12 h-12 absolute left-10 z-20 cursor-pointer top-71.75"
          alt=""
        />
      </a>

      <img
          @click="changeSlide([...controlPoints].reverse().indexOf(chosePoint) + 1)"
          src="@/assets/images/arrow-down-circle.svg"
          class="w-12 h-12 absolute left-24.5 z-20 cursor-pointer top-71.75 "
          alt=""
      />
      <div
          id="slides-list"
          class="slides w-max max-w-none relative flex left-0 pr-screen"
          :class="slidesContainerClasses"
          :style="'left:' + swipe + 'px'"
      >
        <slot name="slides"></slot>
      </div>
    </div>

  </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: "slider",
  props: {
    projects:{
      type: String,
      default:""
    },

    slidesContainerClasses: {
      type: String,
      default: "",
    },
    sliderClasses: {
      type: String,
      default: "",
    },
    similarSlides: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    paginationContainerClasses: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      swiping: false,
      swiped: false,
      touch: {
        current: 0,
        start: 0,
        end: 0,
        sum: 0,
        direction: "",
      },
      chosePoint: 0,
      controlPoints: [],
      slidesHeight: null,
      slides: 0,
      slidesNode:[],
      sliderId:''
    };
  },
  computed: {
    swipe() {
      return this.setSwipe();
    },
    getSlideList(){
      return "#" + this.sliderId + " #slides-list"
    },
    getSlideListContent(){
      return "#" + this.sliderId + " #slides-list > *"
    },
    getActiveSlides(){
      return "#" + this.sliderId + " .active-slide"
    },
    getPaginationItemContent(){
      return "#" + this.sliderId + " .pagination > div > *"
    },
    getPaginationItem(){
      return "#" + this.sliderId + " .pagination > div"
    },
    getPaginationContainer(){
      return "#" + this.sliderId + " .pagination"
    }
  },
  methods: {
    ...mapMutations(['setProject']),
    started(data) {
      this.touch.start = data;
      this.swiping = true;
      this.chosePoint = null;
    },
    moving(data) {
      this.touch.current = data;
    },
    finished(data) {
      this.swiping = false;
      this.touch.end = data;
    },
    setSwipe() {
      if (this.swiping) {
        return this.swipingFunc();
      }
      return this.finishSwipe();
    },
    swipingFunc() {
      if (this.touch.current === 0) {
        return this.touch.sum;
      }
      return this.touch.current - this.touch.start + this.touch.sum;
    },
    finishSwipe() {
      this.touch.sum += this.touch.end - this.touch.start;
      if (
        this.touch.start !== 0 ||
        this.touch.current !== 0 ||
        this.touch.end !== 0
      ) {
        this.swiped = true;
        if (this.touch.end > this.touch.start) {
          this.touch.direction = "back";
        } else if (this.touch.end < this.touch.start) {
          this.touch.direction = "forward";
        }
        this.setControl();
      }
      this.touch.start = this.touch.current = this.touch.end = 0;
      return this.touch.sum;
    },
    setControl() {
      this.controlPoints.forEach((item, index) => {
        if (this.touch.sum < item && index === 0) {
          this.chosePoint = item;
          this.aiming();
          return;
        }
        if (this.touch.sum > item && index + 1 === this.controlPoints.length) {
          this.chosePoint = item;
          this.aiming();
          return;
        }
        if (
          item > this.touch.sum &&
          this.touch.sum > this.controlPoints[index - 1]
        ) {
          let mid = null;
          if (this.touch.direction === "forward") {
            mid =
              (item + this.controlPoints[index - 1]) / 2 -
              (item + this.controlPoints[index - 1]) * 0.25;
          }
          if (this.touch.direction === "back") {
            mid =
              (item + this.controlPoints[index - 1]) / 2 +
              (item + this.controlPoints[index - 1]) * 0.25;
          }
          if (mid > this.touch.sum) {
            this.chosePoint = this.controlPoints[index - 1];
            this.aiming();
            return;
          } else {
            this.chosePoint = item;
            this.aiming();
          }
        }
      });
    },
    aiming() {
      if (this.pagination) {
        this.setPagination();
      }
      this.setActive()
      let duration = 300; // Duration of aiming in milliseconds
      let fps = 60; // Frames per second
      let initial = this.touch.sum;
      if (this.touch.sum >= this.chosePoint) {
        let interval = setInterval(() => {
          this.touch.sum -=
            Math.abs(this.chosePoint - initial) / (fps * (duration / 1000));
          if (
            Math.abs(this.touch.sum - this.chosePoint) <
              window.innerWidth / 200 ||
            this.touch.sum < this.chosePoint
          ) {
            clearInterval(interval);
          }
        }, 1000 / fps);
      } else if (this.touch.sum < this.chosePoint) {
        let interval = setInterval(() => {
          this.touch.sum +=
            Math.abs(this.chosePoint - initial) / (fps * (duration / 1000));
          if (
            Math.abs(this.touch.sum - this.chosePoint) <
              window.innerWidth / 200 ||
            this.touch.sum > this.chosePoint
          ) {
            clearInterval(interval);
          }
        }, 1000 / fps);
      }
    },
    addTouchEvents() {
      document
          .querySelector(this.getSlideList)
        .addEventListener("touchstart", (event) => {
          this.started(event.changedTouches[0].clientX);
        });
      document
        .querySelector(this.getSlideList)
        .addEventListener("touchmove", (event) => {
          this.moving(event.changedTouches[0].clientX);
        });
      document
          .querySelector(this.getSlideList)
        .addEventListener("touchend", (event) => {
          this.finished(event.changedTouches[0].clientX);
        });
    },
    setControlPoints() {
      let slidesContainerStyles = window.getComputedStyle(
        document.querySelector(this.getSlideList)
      );
      let slides = document.querySelectorAll(this.getSlideListContent);
      this.slidesNode = [...slides].reverse()
      this.slides = slides.length;
      if (this.similarSlides) {
        let slideStyles = window.getComputedStyle(slides[0]);

        let slideSize =
          parseFloat(slideStyles.width) + (!isNaN(parseFloat(slidesContainerStyles.gap)) ? parseFloat(slidesContainerStyles.gap) : 0);
        for (let p = 0; p < slides.length; p++) {
          this.controlPoints.unshift(slideSize * p * -1);
        }
      } else {
        let slidesContainerStyles = window.getComputedStyle(
          document.querySelector(this.getSlideList)
        );
        slides.forEach((item, index) => {
          let slideStyles = window.getComputedStyle(item);
          let slideSize =
            parseFloat(slideStyles.width) +
              (!isNaN(parseFloat(slidesContainerStyles.gap)) ? parseFloat(slidesContainerStyles.gap) : 0);

          if (index === 0) {
            this.controlPoints.push(slideSize);
            return;
          }
          this.controlPoints.push(this.controlPoints[index - 1] + slideSize);
        });
        this.controlPoints = this.controlPoints.reverse();
      }
    },
    setPagination() {
      let paginations = document.querySelectorAll(this.getPaginationItemContent);
      paginations = [...paginations].reverse();
      paginations.forEach((item) => {
        item.classList.remove("active");
      });
      paginations[this.controlPoints.indexOf(this.chosePoint)].classList.add(
        "active"
      );
    },
    setActive(){
      document.querySelectorAll(this.getActiveSlides).forEach((item)=>{
        item.classList.remove('active-slide')
      })
      this.slidesNode[this.controlPoints.indexOf(this.chosePoint)].classList.add('active-slide')

    },
    paginationClickHandler(index) {
      let way = "#" + this.sliderId + " #pagination-" + index;
      let item = document.querySelector(way);
      let paginations = document.querySelectorAll(this.getPaginationItem);
      paginations = [...paginations].reverse();
      this.chosePoint = this.controlPoints[paginations.indexOf(item)];
      this.aiming();
    },
    changeSlide(index) {
      if(index >= this.slides){
        index = 0
      }
      let way = "#" + this.sliderId + " #pagination-" + index;
      let item = document.querySelector(way);
      let paginations = document.querySelectorAll(this.getPaginationItem);
      paginations = [...paginations].reverse();
      this.chosePoint = this.controlPoints[paginations.indexOf(item)];
      this.aiming();
    },
  },
  mounted() {
    let slider = document.getElementById('mobile-slider')
    this.sliderId = 'mobile-slider-' + Math.round(Math.random() * 100)

    slider.setAttribute('id', this.sliderId)


    this.addTouchEvents();
    this.setControlPoints();

    if (this.pagination){
      document
          .querySelector(this.getPaginationContainer)
          .addEventListener("DOMNodeInserted", () => {
            if (document.querySelectorAll(this.getPaginationItemContent).length === this.slides){
              document
                  .querySelectorAll(this.getPaginationItemContent)[0]
                  .classList.add("active");
            }
          });
    }

  },
};
</script>

<style scoped lang="scss">
.pagination .active {
  background: red;
}

</style>
